import { pushToDataLayer } from '@domain-group/fe-helper';
function agentProfileInteractionEvent(label) {
  pushToDataLayer({
    event: 'GAevent',
    eventCategory: 'Interaction',
    eventAction: 'Agent Profile',
    eventLabel: label
  });
}
function conversionEvent(action, label) {
  pushToDataLayer({
    event: 'GAevent',
    eventCategory: 'Conversion',
    eventAction: action,
    eventLabel: label
  });
}
export { agentProfileInteractionEvent, conversionEvent };